import request from "@/utils/axios";
import service from '@/utils/axios-v2'

export function getScheduleList(params) {
  return service({
    url: "/fleet/dispatch/v2/load/schedule/query",
    method: "post",
    data: params,
    headers: {
      "portal-token": true
    }
  });
}

export function getAssingLoads(params) {
  return request({
    url: "/fleet/dispatch/v2/load/unassigned/query",
    method: "get",
    data: params,
    headers: {
      "portal-token": true
    }
  });
}

export function addScheduleEvent(params) {
  return service({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: "/zuul/schedule/event/add",
    method: "post",
    data: params,
    headers: {
      "portal-token": true
    }
  });
}

export function editScheduleEvent(params) {
  return service({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: "/zuul/schedule/event/edit",
    method: "post",
    data: params,
    headers: {
      "portal-token": true
    }
  });
}

export function delScheduleEvent(params) {
  return service({
    url: "/fleet/dispatch/v2/schedule/event/delete",
    method: "put",
    params,
    headers: {
      "portal-token": true
    }
  });
}









